import { useEffect, useState } from "react";
import ExportGoalsModal from "../../components/ExportGoalsModal";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";

const GoalsTab = ({ tournament, selectedSubcategory }) => {
  const [topScorers, setTopScorers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Nuevos estados para la exportación y el límite
  const [limit, setLimit] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = useSelector((state) => state.user.token);
  const [userId, setUserId] = useState("");
  const defaultPlayerImage =
    "https://cdn-icons-png.flaticon.com/512/149/149071.png";

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserId(decodedToken.id);
      } catch (error) {
        console.error("Error decodificando token:", error);
      }
    }
  }, [token]);

  useEffect(() => {
    if (!tournament?.id) return;

    const fetchTopScorers = async () => {
      try {
        const url = selectedSubcategory
          ? `${process.env.REACT_APP_API_URL}/api/goals/${tournament.id}/top-scorers?subcategoryId=${selectedSubcategory.id}`
          : `${process.env.REACT_APP_API_URL}/api/goals/${tournament.id}/top-scorers`;

        const res = await fetch(url);
        const data = await res.json();
        setTopScorers(data);
      } catch (error) {
        console.error("Error al cargar goleadores:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopScorers();
  }, [tournament, selectedSubcategory]);

  if (loading) return <p>Cargando goleadores...</p>;

  // Filtramos la lista según el límite seleccionado
  const visibleScorers = topScorers.slice(0, limit);

  return (
    <>
      <div>
        <div className="flex flex-wrap items-center justify-between mb-4 gap-4">
          <h3 className="font-semibold text-green-700 flex items-center m-0">
            ⚽ Goleadores
          </h3>

          {/* Controles: Selector de cantidad y Botón de exportar */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <label
                htmlFor="scorer-limit"
                className="text-sm text-gray-600 font-medium"
              >
                Mostrar:
              </label>
              <select
                id="scorer-limit"
                value={limit}
                onChange={(e) => setLimit(Number(e.target.value))}
                className="text-sm border border-gray-300 rounded-lg px-2 py-1.5 focus:ring-green-500 focus:border-green-500 bg-white"
              >
                <option value={3}>Top 3</option>
                <option value={5}>Top 5</option>
                <option value={10}>Top 10</option>
                <option value={topScorers.length}>Todos</option>
              </select>
            </div>

            {userId === tournament.user_id && (
              <button
                onClick={() => setIsModalOpen(true)}
                disabled={visibleScorers.length === 0}
                className="px-3 py-1.5 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm flex items-center gap-2 disabled:bg-gray-400"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                  ></path>
                </svg>
                Exportar
              </button>
            )}
          </div>
        </div>

        {visibleScorers.length > 0 ? (
          <div className="space-y-2">
            {visibleScorers.map((player, index) => (
              <div
                key={`${player.player_id}-${index}`}
                className="flex items-center p-3 bg-white rounded-lg border border-green-200 shadow-sm hover:shadow-md transition"
              >
                {/* Posición */}
                <span className="w-8 text-center font-bold text-gray-700">
                  {index + 1}°
                </span>

                {/* Jugador */}
                <div className="flex items-center flex-1 ml-4">
                  <img
                    src={player.profile_picture_url || defaultPlayerImage}
                    alt={player.player_name}
                    className="w-10 h-10 rounded-full object-cover border-2 border-white shadow"
                  />

                  <div className="ml-3 flex-1">
                    <h4 className="font-medium text-gray-900">
                      {player.player_name}
                    </h4>
                    <div className="flex items-center mt-1">
                      {player.team_logo && (
                        <img
                          src={player.team_logo}
                          alt={player.team_name}
                          className="w-5 h-5 mr-2 object-contain"
                        />
                      )}
                      <span className="text-xs text-gray-600">
                        {player.team_name}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Goles */}
                <div className="ml-auto bg-green-100 px-3 py-1 rounded-full border border-green-400 flex items-center">
                  <span className="font-bold text-green-800">
                    {player.goals}
                  </span>
                  <span className="text-xs text-green-700 ml-1">goles</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">
            No hay datos de goleadores disponibles
          </p>
        )}
      </div>

      <ExportGoalsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        scorers={visibleScorers}
        subcategory={selectedSubcategory}
      />
    </>
  );
};

export default GoalsTab;
